import React, {useState} from 'react';
import { Table, TableProps } from 'antd';
import {CategoryTableData, TopicTableData} from '../types';
import {contentService} from "../../../core/services";
import {Spinner, Pagination} from "react-bootstrap";
import AnswerResult from "../../partials/answerResult";
import {Link} from "react-router-dom";

interface TopicsTableProps {
    data: TopicTableData[];
    isContentsVisible: boolean;
    studentId?: string
}

const TopicsTable: React.FC<TopicsTableProps> = ({ data, isContentsVisible, studentId }) => {
    const [contents, setContents] = useState({});
    const [selectedAnswers, setSelectedAnswers] = useState<any[] | null>(null);
    const [selectedQuestion, setSelectedQuestion] = useState<string | null>(null);
    const [modalTitle, setModalTitle] = useState<string | null>(null)
    const [currentIndex, setCurrentIndex] = useState(0);
    const topicColumns: TableProps<TopicTableData>['columns'] = [
        { title: 'Topics', dataIndex: 'name', key: 'name', width: '40%' },
        { title: 'Total Activity', dataIndex: 'totalActivity', key: 'totalActivity', sorter: (a, b) => a.totalActivity - b.totalActivity },
        { title: 'Total Success', dataIndex: 'totalSuccess', key: 'totalSuccess', sorter: (a, b) => a.totalSuccess - b.totalSuccess },
        {
            title: 'Success Score (%)',
            dataIndex: 'successScore',
            key: 'successScore',
            render: (score: number) => (
                <span className={`badge badge-sm ${score >= 70 ? 'bg-success' : score > 0 ? 'bg-warning' : 'bg-secondary'} d-inline-flex align-items-center`}>
                    {score}%
                </span>
            ),
            sorter: (a, b) => a.successScore - b.successScore,
        },
    ];

    const onClickedExpand = (record: any, expanded: any) => {
        if (expanded){
            return;
        }
        const [topicId, levelId, categoryId] = record.key.split("_")
        // @ts-ignore
        if (contents.hasOwnProperty(levelId) && contents[levelId].hasOwnProperty(topicId)){
            return;
        }
        contentService.getAll({
            level: levelId,
            category: categoryId
        }).then(r => {
            const topicContents = r.filter(x => x.topic_id === parseInt(topicId))
            // @ts-ignore
            setContents(prev => ({
                ...prev,
                [levelId]: {
                    // @ts-ignore
                    ...(prev.hasOwnProperty(levelId) ? prev[levelId] : {}),
                    [topicId]: topicContents
                }
            }))
        })

    }

    const onClickReports = (contentId: number, levelId: number, topicId: number) => {
        console.log()
        setSelectedAnswers(null);
        setSelectedQuestion(null);
        setModalTitle(null)
        setCurrentIndex(0);
        //@ts-ignore
        contentService.getAnswerResultsStudent(contentId, studentId).then(r => {
            setSelectedAnswers(r)
            //@ts-ignore
            setSelectedQuestion(contents[levelId][topicId].filter(x => x.id === contentId)[0].detail)
            //@ts-ignore
            setModalTitle(contents[levelId][topicId].filter(x => x.id === contentId)[0].title)
        })
    }

    const onCloseReportModal = () => {
        setCurrentIndex(0);
        setSelectedAnswers(null)
        setSelectedQuestion(null);
        setModalTitle(null)
    }

    const handlePageChange = (index: number) => {
        setCurrentIndex(index);
    };

    const CustomExpandIcon = ({ expanded, onExpand, record }: any) => (
        <span
            onClick={e => {
                onExpand(record, e);
                onClickedExpand(record, expanded)
            }}
            style={{
                cursor: 'pointer',
                fontSize: '14px',
                color: '#000',
                padding: '0 5px',
                transition: 'transform 0.3s ease-in-out',
                display: 'inline-block',
                transform: expanded ? 'rotate(45deg)' : 'rotate(0deg)',
                lineHeight: 1
            }}
            className="fa fa-plus"
            aria-label={expanded ? "Collapse row" : "Expand row"}
        />
    );

    const expandedRowRender = (d: any) => {
        const [topicId, levelId, categoryId] = d.key.split("_")
        // @ts-ignore
        if (contents.hasOwnProperty(levelId) && contents[levelId].hasOwnProperty(topicId)){
            return <Table
                // @ts-ignore
                dataSource={contents[levelId][topicId]}
                columns={[{
                    title: "Activities",
                    dataIndex: "title",
                    key: "contents",
                    width: "50%"
                }, {
                    title: "Actions",
                    dataIndex: "id",
                    key: "actions",
                    width: "50%",
                    render: (id: number) => {
                        return (
                            <Link
                                to={"#"}
                                onClick={() => onClickReports(id, levelId, topicId)}
                                data-bs-toggle="modal"
                                data-bs-target="#see_reports"
                            >
                                <i className="isax isax-eye"></i> Reports
                            </Link>
                        )
                    }
                }]}
                pagination={false}
                size="small"
            />
        }
        return <Spinner/>;
    };

    return (
        <div style={{ margin: '10px 0 10px 40px' }}>
            {/* <h6 className="mb-3">Topics in this Skill</h6> */}
            <Table
                dataSource={data}
                columns={topicColumns}
                pagination={false}
                size="small"
                expandable={isContentsVisible ? {
                    expandedRowRender,
                    expandIcon: CustomExpandIcon,
                    expandIconColumnIndex: 0,
                } : {}}
            />
            <div className="modal fade" id="see_reports" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <span style={{
                                fontWeight: "bold"
                            }}>{modalTitle}</span>
                            <button
                                type="button"
                                className="btn-close custom-btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={onCloseReportModal}
                            >
                                <i className="isax isax-close-circle5" />
                            </button>

                        </div>
                            <div className="modal-body pb-0">
                                {selectedAnswers === null ? (
                                    <div className="text-center p-5"><Spinner animation="border" /></div>
                                ) : selectedAnswers.length > 0 ? (
                                    <>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: selectedQuestion!
                                            }}
                                            style={{ marginBottom: "15px" }}
                                        />
                                        <AnswerResult answerResult={selectedAnswers[currentIndex]} />
                                    </>
                                ) : (
                                    <div className="text-center p-5">No reports found.</div>
                                )}

                            </div>

                        {selectedAnswers && selectedAnswers.length > 1 && (
                            <div className="modal-footer d-flex justify-content-center">
                                <Pagination className="mb-0">
                                    <Pagination.Prev
                                        onClick={() => handlePageChange(currentIndex - 1)}
                                        disabled={currentIndex === 0}
                                    />

                                    {selectedAnswers.map((_, idx) => (
                                        <Pagination.Item
                                            key={idx}
                                            active={idx === currentIndex}
                                            onClick={() => handlePageChange(idx)}
                                        >
                                            {idx + 1}
                                        </Pagination.Item>
                                    ))}

                                    <Pagination.Next
                                        onClick={() => handlePageChange(currentIndex + 1)}
                                        disabled={currentIndex === selectedAnswers.length - 1}
                                    />
                                </Pagination>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(TopicsTable);